import React from 'react'
import { makeStyles } from '@material-ui/styles'
import Box from '@material-ui/core/Box'
import MessageList from './MessageList'
import ClapChart from './ClapChart'
import CalendarView from './CalendarView'

const useStyles = makeStyles(theme => ({
	wrap: {
		[theme.breakpoints.up('md')]: {
			height: 550,
			display: 'flex',
		},
	},
	leftWrap: {
		[theme.breakpoints.up('md')]: {
			display: 'flex',
			flexDirection: 'column',
			flex: 0,
		},
		[theme.breakpoints.down('sm')]: {
			marginBottom: theme.spacing(2),
		},
	},
	calendar: {
		overflow: 'hidden',
		flexShrink: 0,
		marginBottom: theme.spacing(2),
	},
	message: {
		flexGrow: 1,
		backgroundColor: '#fafafa',
		[theme.breakpoints.up('md')]: {
			display: 'flex',
			flexDirection: 'column',
			height: 230,
		},
	},
	chart: {
		[theme.breakpoints.up('md')]: {
			marginLeft: theme.spacing(2),
			flexGrow: 1,
			display: 'flex',
			flexDirection: 'column',
		},
	},
}))

function MessagePanel() {
	const classes = useStyles()

	return (
		<Box className={classes.wrap}>
			<Box className={classes.leftWrap}>
				<Box className={classes.calendar}>
					<CalendarView />
				</Box>
				<Box className={classes.message} boxShadow={1} fontSize="body2.fontSize">
					<MessageList />
				</Box>
			</Box>
			<Box className={classes.chart}>
				<ClapChart />
			</Box>
		</Box>
	)
}

export default MessagePanel
